import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function Home() {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    navigate(`/services?search=${encodeURIComponent(searchQuery)}`);
  };

  const fetchFeaturedServices = async () => {
    try {
      const response = await fetch(`${API_URL}/api/services/featured`);
      // rest of the code...
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <div className="max-w-4xl mx-auto">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          Find Pet Services in San Francisco
        </h1>
        <p className="text-xl text-gray-600">
          Discover the best pet care services for your furry friends
        </p>
      </div>

      <form onSubmit={handleSearch} className="mb-12">
        <div className="flex gap-4">
          <input
            type="text"
            placeholder="Search for pet services..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="flex-1 p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
          <button
            type="submit"
            className="px-8 py-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Search
          </button>
        </div>
      </form>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[
          { display: 'Grooming', value: 'grooming' },
          { display: 'Veterinary', value: 'veterinarian' },
          { display: 'Training', value: 'training' },
          { display: 'Pet Sitting', value: 'sitting' },
          { display: 'Emergency Care', value: 'emergency' },
          { display: 'Pet Supplies', value: 'supplies' }
        ].map(
          (service) => (
            <div
              key={service.display}
              className="p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow cursor-pointer"
              onClick={() => navigate(`/services?category=${service.value}`)}
            >
              <h3 className="text-xl font-semibold mb-2">{service.display}</h3>
              <p className="text-gray-600">Find the best {service.display.toLowerCase()} services in SF</p>
            </div>
          )
        )}
      </div>
    </div>
  );
}

export default Home; 